// extracted by mini-css-extract-plugin
export default {"popover":"CustomHover_popover__FJDrn","title":"CustomHover_title__nnC59","body":"CustomHover_body__RiR3B","button":"CustomHover_button__0cGSe"};